import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import DeleteSubscriptionItemPricingOverrideFormModal from 'src/features/subscriptionItemPricingOverrides/components/forms/DeleteSubscriptionItemPricingOverrideFormModal';
import UpdateSubscriptionItemPricingOverrideFormModal from 'src/features/subscriptionItemPricingOverrides/components/forms/UpdateSubscriptionItemPricingOverrideFormModal';
import { pricingOverridesMessages } from 'src/features/subscriptionItemPricingOverrides/utils/messages';
import { SubscriptionItemPricingOverride } from 'src/features/subscriptionItemPricingOverrides/utils/types';

type CellSubscriptionItemPricingOverrideActionsProps = {
    row: Row<SubscriptionItemPricingOverride>;
};

export default function CellSubscriptionItemPricingOverrideActions({
    row,
}: CellSubscriptionItemPricingOverrideActionsProps) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateSubscriptionItemPricingOverrideFormModal
                        semantics={{ entryName: formatMessage(pricingOverridesMessages.pricingOverride) }}
                        selectedPricingOverride={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateSubscriptionItemPricingOverrideFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteSubscriptionItemPricingOverrideFormModal selectedPricingOverride={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteSubscriptionItemPricingOverrideFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
